export var Transmission;
(function (Transmission) {
    Transmission["AUTOMATIC"] = "AUTOMATIC";
    Transmission["MANUAL"] = "MANUAL";
})(Transmission || (Transmission = {}));
